import { getGoalSiteAri } from '@atlassian/projects-goals-common/get-app-site-ari';
import { PreloadedQuery } from 'react-relay';
import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalAccessPermissionsSettingsAggQuery, {
	type GoalAccessPermissionsSettingsAggQuery as GoalAccessPermissionsSettingsAggQueryType,
} from '../../components/GoalAccessPermissionsSettings/__generated__/GoalAccessPermissionsSettingsAggQuery.graphql';

export const goalAccessPermissionsSettingsResource: RouteResource<
	PreloadedQuery<GoalAccessPermissionsSettingsAggQueryType, Record<string, unknown>>
> = createRelayResource<GoalAccessPermissionsSettingsAggQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const variables: VariablesOf<GoalAccessPermissionsSettingsAggQueryType> = {
			containerId: getGoalSiteAri(context.collabContext?.contextId ?? ''),
			isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
		};

		return {
			query: GoalAccessPermissionsSettingsAggQuery,
			variables,
			environment: getAggRelayEnvironment(),
		};
	},
});
